// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import { App } from './app'
import { store } from './app'
import router from './router'
import auth from './app/service/AuthService'
import BootstrapVue from 'bootstrap-vue'
import 'expose-loader?$!expose-loader?jQuery!jquery'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.css'
import './assets/js/datatable-date-euro'
import XLSX from 'xlsx';

Vue.use(VueMaterial);
Vue.use(auth);
Vue.use(BootstrapVue);
Vue.use(XLSX);

Vue.config.productionTip = false;

/* eslint-disable no-new */
window.app = new Vue({
  el: '#app',
  router,
  store,
  auth,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js